<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>


                <li v-if="ckLoginAdmin" @mouseover="showSettingsMenu = true" @mouseleave="showSettingsMenu = false">
                    <img src="@/assets/icons/menuSettings.svg" />
                    <span>Configurações</span>
                    <div v-if="showSettingsMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('FrotaAlertaHybridPage', 'ALERTAS POR EMAIL')">
                                <span>Alertas</span>
                            </li>
                            
                            <li @click="setComponenteAtivo('DespesasGruposTabPage', 'GRUPOS DE DESPESA')">
                                <span>Grupos de Despesa</span>
                            </li>

                            <li @click="setComponenteAtivo('EquipamentosGruposTabPage', 'GRUPOS DE EQUIPAMENTO')">
                                <span>Grupos de Equipamento</span>
                            </li>

                            <li @click="setComponenteAtivo('ChecklistModeloTabPage', 'MODELOS DE CHECKLIST')">
                                <span>Modelos de Checklist</span>
                            </li>

                            <li @click="setComponenteAtivo('ManutPlanoTabPage', 'PLANOS DE MANUTENÇÃO')">
                                <span>Planos de Manutenção</span>
                            </li>

                            <li @click="setComponenteAtivo('ManutServicoTabPage', 'SERVIÇOS')">
                                <span>Serviços de Manutenção</span>
                            </li>

                            <li @click="setComponenteAtivo('EquipamentosSetoresTabPage', 'SETORES')">
                                <span>Setores</span>
                            </li>

                            <li @click="selectOption('UsuariosTabPage', 'USUÁRIOS')">
                                <span>Usuários</span>
                            </li>
                        </ul>
                    </div>
                </li>


                
                <li @mouseover="showCadastrosMenu = true" @mouseleave="showCadastrosMenu = false">
                    <img src="@/assets/icons/menuOpcoes.svg" />
                    <span>Cadastros</span>
                    <div v-if="showCadastrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('OperadoresTabPage', 'CONDUTORES E OPERADORES')">
                                <span>Condutores e Operadores</span>
                            </li>

                            <li @click="setComponenteAtivo('OperadoresDocumentosTabPage', 'DOCUMENTOS CONDUTORES')">
                                <span>Documentos de Condutores</span>
                            </li>

                            <li @click="setComponenteAtivo('FornecedoresTabPage', 'FORNECEDORES')">
                                <span>Fornecedores</span>
                            </li>

                            <li @click="setComponenteAtivo('EquipamentosTabPage', 'VEÍCULOS E EQUIPAMENTOS')">
                                <span>Veículos e Equipamentos</span>
                            </li>

                            <li @click="setComponenteAtivo('ProdutosTabPage', 'PRODUTOS DE CONSUMO')">
                                <span>Produtos</span>
                            </li>
                        </ul>
                    </div>
                </li>
                

                <li @mouseover="showManutencoesMenu = true" @mouseleave="showManutencoesMenu = false">
                    <img src="@/assets/icons/repair.svg" />
                    <span>Manutenções e OS</span>
                    <div v-if="showManutencoesMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('ManutOsSolicitacaoPage', 'MANUTENÇÕES - SOLICITAÇÃO')">
                                <span>Incluir Solicitação de Serviço</span>
                            </li>
                            
                            <li @click="selectOption('ManutOsOrcamentoPage', 'MANUTENÇÕES - ANEXAR ORÇAMENTO')">
                                <span>Anexar Orçamentos</span>
                            </li>
                            
                            <li @click="selectOption('ManutOsAprovacaoPage', 'MANUTENÇÕES - APROVAÇÃO DE ORÇAMENTO')">
                                <span>Aprovar Orçamentos</span>
                            </li>
                            
                            <li @click="selectOption('ManutOsExecucaoPage', 'MANUTENÇÕES - CONFIRMAR EXECUÇÃO')">
                                <span>Confirmar Execução de Serviços</span>
                            </li>

                            <li @click="selectOption('ManutOsTabPage', 'MANUTENÇÕES')">
                                <span>Tabela de Manutenções</span>
                            </li>

                            <li @click="selectOption('ManutAlertasTabPage', 'MANUTENÇÕES - CONSULTA DE ALERTAS')">
                                <span>Consultar alertas</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showDespesasMenu = true" @mouseleave="showDespesasMenu = false">
                    <img src="@/assets/icons/menuMoney.svg" />
                    <span>Operações</span>
                    <div v-if="showDespesasMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('DespesasEditPage', 'DESPESAS - LANÇAMENTO')">
                                <span>Despesas - Incluir lançamento</span>
                            </li>

                            <li @click="selectOption('DespesasTabPage', 'DESPESAS - CONSULTAR LANÇAMENTOS')">
                                <span>Despesas - Tabela de lançamentos</span>
                            </li>

                            <li @click="selectOption('LicitacaoEditPage', 'LICITAÇÕES - INCLUIR CONTRATOS')">
                                <span>Licitações - Incluir Contrato</span>
                            </li>

                            <li @click="selectOption('LicitacoesTabPage', 'LICITAÇÕES - CONSULTAR CONTRATOS')">
                                <span>Licitações - Tabela de Contratos</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showopcionaisMenu = true" @mouseleave="showopcionaisMenu = false">
                    <img src="@/assets/icons/module.svg" />
                    <span>Ferramentas e Utilitários</span>
                    <div v-if="showopcionaisMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('ChecklistTabPage', 'CHECKLIST DE EQUIPAMENTOS/VEÍCULOS')">
                                <span>Consulta checklist</span>
                            </li>

                            <li @click="setComponenteAtivo('ManutMailAlertasTabPage', 'ENVIO DE ALERTAS')">
                                <span>Envio de alertas</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showManutencoesDados = true" @mouseleave="showManutencoesDados = false">
                    <img src="@/assets/icons/menuEdit.svg" />
                    <span>Manutenções de Dados</span>
                    <div v-if="showManutencoesDados" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('EquipamentosKmHorasManutPage', 'CONSULTA E AJUSTE DE KM/HORAS')">
                                <span>Apontamentos de KM/Horas</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.svg" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('DespesasReportPage', 'RELATÓRIO DE DESPESAS')">
                                <span>Despesas</span>
                            </li>
                            
                            <li @click="selectOption('EquipamentoReportPage', 'RELATÓRIO DE EQUIPAMENTO/VEÍCULOS')">
                                <span>Equipamentos e Veículos</span>
                            </li>
                            
                            <li @click="selectOption('LicitacaoReportPage', 'RELATÓRIO DE LICITAÇÕES')">
                                <span>Licitações</span>
                            </li>
                            
                            <li @click="selectOption('FrotaManutencoesReportPage', 'RELATÓRIO DE MANUTENÇÕES')">
                                <span>Manutenções</span>
                            </li>
                            
                            <li v-if="ckLoginAdmin" @click="selectOption('LogSistemaReportPage', 'RELATÓRIOS DO SISTEMA')">
                                <span>Log de sistema</span>
                            </li>
                        </ul>
                    </div>
                </li>

                <li @click="setComponenteAtivo('UsuarioViewPage', 'DADOS DO USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Dados de usuário</span>
                </li>

                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GESTÃO DE FROTA' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ loginStore.userData.nome }}</div>
                        <div class="establishment-name">{{ loginStore.userData.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=globalStore.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FrotaAlertaHybridPage'"><FrotaAlertaHybridPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='ChecklistTabPage'"><ChecklistTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosKmHorasManutPage'"><EquipamentosKmHorasManutPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutMailAlertasTabPage'"><ManutMailAlertasTabPage @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='DespesasReportPage'"><DespesasReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentoReportPage'"><EquipamentoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FrotaManutencoesReportPage'"><FrotaManutencoesReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LicitacaoReportPage'"><LicitacaoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LogSistemaReportPage'"><LogSistemaReportPage @close="setComponenteAtivo(null, null)"/></div>


                    <div v-else-if="nmComponenteAtivo=='ChecklistModeloTabPage'"><ChecklistModeloTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DespesasGruposTabPage'"><DespesasGruposTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosTabPage'"><EquipamentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosGruposTabPage'"><EquipamentosGruposTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosSetoresTabPage'"><EquipamentosSetoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FornecedoresTabPage'"><FornecedoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutPlanoTabPage'"><ManutPlanoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutServicoTabPage'"><ManutServicoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='OperadoresTabPage'"><OperadoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='OperadoresDocumentosTabPage'"><OperadoresDocumentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosTabPage'"><ProdutosTabPage @close="setComponenteAtivo(null, null)"/></div>


                    <div v-else-if="nmComponenteAtivo=='DespesasTabPage'"><DespesasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DespesasEditPage'"><DespesasEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LicitacaoEditPage'"><LicitacaoEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LicitacoesTabPage'"><LicitacoesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutAlertasTabPage'"><ManutAlertasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutOsAprovacaoPage'"><ManutOsAprovacaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutOsExecucaoPage'"><ManutOsExecucaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutOsOrcamentoPage'"><ManutOsOrcamentoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutOsSolicitacaoPage'"><ManutOsSolicitacaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ManutOsTabPage'"><ManutOsTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else><FrotaDash2 /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';


import FrotaDash2 from '../dashboard/FrotaDash2.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';


import ChecklistTabPage from '../frota/tabelas/ChecklistTabPage.vue';
import ManutMailAlertasTabPage from '../frota/formularios/ManutMailAlertasTabPage.vue';

import EquipamentosKmHorasManutPage from '../manutencoes/EquipamentosKmHorasManutPage.vue';


// CADASTROS
import ChecklistModeloTabPage from '../cadastros/tabelas/ChecklistModeloTabPage.vue';
import DespesasGruposTabPage from '../cadastros/tabelas/DespesasGruposTabPage.vue';
import EquipamentosTabPage from '../cadastros/tabelas/EquipamentosTabPage.vue';
import EquipamentosGruposTabPage from '../cadastros/tabelas/EquipamentosGruposTabPage.vue';
import EquipamentosSetoresTabPage from '../cadastros/tabelas/EquipamentosSetoresTabPage.vue';
import FornecedoresTabPage from '../cadastros/tabelas/FornecedoresTabPage.vue';
import ManutPlanoTabPage from '../cadastros/tabelas/ManutPlanoTabPage.vue';
import ManutServicoTabPage from '../cadastros/tabelas/ManutServicoTabPage.vue';
import OperadoresTabPage from '../cadastros/tabelas/OperadoresTabPage.vue';
import OperadoresDocumentosTabPage from '../cadastros/tabelas/OperadoresDocumentosTabPage.vue';
import ProdutosTabPage from '../cadastros/tabelas/ProdutosTabPage.vue';

// OPERAÇÕES
import DespesasEditPage from '../frota/formularios/DespesasEditPage.vue';
import DespesasTabPage from '../frota/tabelas/DespesasTabPage.vue';
import LicitacaoEditPage from '../frota/formularios/LicitacaoEditPage.vue';
import LicitacoesTabPage from '../frota/tabelas/LicitacoesTabPage.vue';
import ManutAlertasTabPage from '../frota/tabelas/ManutAlertasTabPage.vue';
import ManutOsAprovacaoPage from '../frota/operacional/ManutOsAprovacaoPage.vue';
import ManutOsExecucaoPage from '../frota/operacional/ManutOsExecucaoPage.vue';
import ManutOsOrcamentoPage from '../frota/operacional/ManutOsOrcamentoPage.vue';
import ManutOsSolicitacaoPage from '../frota/operacional/ManutOsSolicitacaoPage.vue';
import ManutOsTabPage from '../frota/tabelas/ManutOsTabPage.vue';

// SUBMENU CONFIGURAÇÕES
import FrotaAlertaHybridPage from '../frota/hybrid/FrotaAlertaHybridPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';

// SUBMENU RELATÓRIOS
import DespesasReportPage from '../reports/DespesasReportPage.vue';
import EquipamentoReportPage from '../reports/EquipamentoReportPage.vue';
import FrotaManutencoesReportPage from '../reports/FrotaManutencoesReportPage.vue';
import LicitacaoReportPage from '../reports/LicitacaoReportPage.vue';
import LogSistemaReportPage from '../reports/LogSistemaReportPage.vue';

const ckLoginAdmin= ref(false);
const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showCadastrosMenu = ref(false);
const showDespesasMenu = ref(false);
const showManutencoesDados = ref(false);
const showManutencoesMenu = ref(false);
const showopcionaisMenu = ref(false);
const showRelatoriosMenu = ref(false);
const showSettingsMenu = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;


const menuIcon = computed(() => {
    return isCollapsed.value
        ? require('@/assets/icons/menuRight.svg')
        : require('@/assets/icons/menuLeft.svg');
})


const confirmLogout = () => {resetLogin();}


const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}


const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }


const selectOption = (page, titulo) => {
    nmComponenteAtivo.value     = page;
    nmTitulo.value              = titulo;
    showCadastrosMenu.value     = false;
    showDespesasMenu.value      = false;
    showManutencoesMenu.value   = false;
    showopcionaisMenu.value     = false;
    showRelatoriosMenu.value    = false;
    showSettingsMenu.value      = false;
}


const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}


const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
}


onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
    ckLoginAdmin.value = globalStore.ckadmin==='S';
})


onBeforeUnmount(() => {
    clearInterval(timer);
})
</script>